export default function ($http) {
    return function (vehicleId, mileageModel) {
        return $http.post(`api/vehicles/${vehicleId}/mileages`, mileageModel);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/mileages/addMileage.js